import {useContext} from 'react'
import {ListViewPageContext} from '../../../context'
import {DynamicTable} from '../../../../../components/DynamicTable'
import ListViewTableRow from './ListViewTableRow'
import {listViewTicketColumns} from '../../../utils'

const ListViewTable = () => {
  const {
    hasListViewPermission,
    agileBoardTicketList,
    isLoadingAgileBoardTicketList,
    filters,
    onSearch,
    onSortingChange,
    isLoadingTicketOperation,
    agileBoardTicketMeta,
    checkedRows,
    setCheckedRows,
  } = useContext(ListViewPageContext)

  return (
    <DynamicTable
      sortableColumns={listViewTicketColumns(agileBoardTicketMeta)}
      data={agileBoardTicketList}
      TableRow={ListViewTableRow}
      loading={isLoadingAgileBoardTicketList || isLoadingTicketOperation}
      filters={filters}
      onSearch={onSearch}
      onSortingChange={onSortingChange}
      checkedRows={checkedRows}
      setCheckedRows={setCheckedRows}
      hasPermission={hasListViewPermission}
      checkedRowId='id'
      tableRowProps={{
        customFields: agileBoardTicketMeta,
      }}
    />
  )
}

export default ListViewTable
